(function($, d, w) {

    w.addEventListener(w.ZP_DEFAULT.ZP_EVENT_DOM_READY, () => {
        //ZP_DEFAULT.swup.on('pageView', onInit); //TODO
        onInit();
    });

    function onInit()  {
        console.log('TEST');
        const elements = $('.zp_news');
        if(elements.length > 0) {
            elements.each((index, element) => {
                new News($(element), $(element).attr("id"));
            });
        }
    }

    class News {

        constructor(root, id) {

            this.id = id;

            this.ELEMENTS = {
                $root: root,
                $grid: root.find(".grid"),
                $links: root.find(".grid .grid-item .link"),
                $more: root.find(".load-more .load-more-button"),
            };

            let getPost = this.ELEMENTS.$root.attr("data-load-post");
            this.isLoadingPost = false;
            this.isLoadingMore = false;
            this.hasMore = true;

            this.count = parseInt(this.ELEMENTS.$root.attr("data-count"));
            this.offset = parseInt(this.ELEMENTS.$root.attr("data-offset"));
            this.readMore = this.ELEMENTS.$root.attr("data-read-more");

            let grid = this.ELEMENTS.$grid.isotope({
                percentPosition: false,
                itemSelector: '.grid-item',
                transitionDuration: 600,
                hiddenStyle: {
                    opacity: 0,
                    transform: 'translateY(20px)',
                },
                visibleStyle: {
                    transform: 'translateY(0)',
                    opacity: 1
                }
            });

            grid.imagesLoaded().progress( function() {

                grid.isotope('layout');

            });

            this.ELEMENTS.$more.on("click", this.clickMore.bind(this));

            this.addOpenListener();

            this.$container = this.ELEMENTS.$root.find(".zp-news-holder");
            this.$container.appendTo("body");
            this.$container.find(".zp-news-holder-bg, .zp-news-holder-content-close").on("click", this.clickClosePost);

            if (getPost !== "none") {

                setTimeout(function() {

                        this.loadPost(getPost);

                }.bind(this), 200);

            }

        }

        addOpenListener() {

            let $elements = this.ELEMENTS.$root.find(".article:not(.ready)");
            $elements.find("a").on("click", {root: this}, this.clickOpenPost);
            $elements.addClass("ready");

        }

        clickOpenPost(e) {

            e.preventDefault();
            e.stopImmediatePropagation();

            let $this = e.data.root;

            let id = $(this).closest(".grid-item").attr("data-post-id");

            $this.loadPost(id);

        }

        clickClosePost(e) {

            e.preventDefault();
            e.stopImmediatePropagation();

            $(".zp-news-holder").removeClass("show").removeClass("loaded");

            setTimeout(function(){

                $(".zp-news-holder").removeClass("active").removeClass("loaded");

            }, 600);

        }

        loadPost(id) {

            if(!this.isLoadingPost) {

                this.isLoadingPost = true;

                let $holder = $(".zp-news-holder");
                $holder.addClass("active");

                setTimeout(function () {

                    $(".zp-news-holder").addClass("show");

                    let $this = this;
                    let $holder = $(".zp-news-holder");
                    let $articleHolder = $holder.find(".zp-news-holder-article");
                    $articleHolder.empty();

                    $.ajax({
                        type: "post",
                        data: {
                            action: "zp_news_ajax",
                            ajax: true,
                            id: id,
                            type: 'load_post',
                        },
                        url: zpAjax.ajaxUrl,
                        success: function (response) {

                            if (response.replace(/\s+/, "") !== "") {

                                $(response).appendTo($articleHolder);

                                $this.addPostListener();

                            }

                            $holder.addClass("loaded");

                            $this.isLoadingPost = false;
                        }
                    });

                }.bind(this), 1);
            }

        }

        addPostListener() {

            let $holder = $(".zp-news-holder");
            let $articleHolder = $holder.find(".zp-news-holder-article");
            let $button = $articleHolder.find(".controls .button").on("click", {root: this}, this.clickPrevNextPost);

        }

        clickPrevNextPost(e) {

            e.preventDefault();
            e.stopImmediatePropagation();

            let $root = e.data.root;
            let id = $(this).attr("data-post-id");

            $(".zp-news-holder").removeClass("loaded");

            setTimeout(function(){

                $root.loadPost(id);

            }, 600);

        }

        clickMore() {

            this.loadMore();

        }

        loadMore() {

            if(!this.isLoadingMore) {

                this.isLoadingMore = true;
                let $this = this;
                $this.ELEMENTS.$root.addClass("is-loading-more");

                $.ajax({
                    type: "post",
                    data: {
                        action: "zp_news_ajax",
                        ajax: true,
                        count: $this.count,
                        readmore: $this.readMore,
                        offset: $this.offset + $this.count,
                        type: 'load_more',
                    },
                    url: zpAjax.ajaxUrl,
                    success: function (response) {

                        if(response.replace(/\s+/, "") !== "") {

                            $this.ELEMENTS.$root.removeClass("no-more");
                            $this.ELEMENTS.$root.addClass("is-loading-more");

                            let $newElements = $(response);
                            $newElements.imagesLoaded(function() {

                                $this.offset = $this.offset + $this.count;
                                $this.ELEMENTS.$grid.append($newElements).isotope('appended', $newElements);

                                if($this.ELEMENTS.$root.find(".article:not(.ready)").length < $this.count) {

                                    $this.ELEMENTS.$root.addClass("no-more");
                                    $this.hasMore = false;

                                } else {

                                    $this.checkHasMore();

                                }

                                $this.addOpenListener();

                                $this.ELEMENTS.$grid.isotope('layout');


                            });

                        } else {

                            $this.ELEMENTS.$root.addClass("no-more");
                            $this.hasMore = false;
                            $this.isLoadingMore = false;
                            $this.ELEMENTS.$root.removeClass("is-loading-more");

                        }
                    }
                });

            }

        }

        checkHasMore() {

            this.isLoadingMore = true;
            let $this = this;
            $this.ELEMENTS.$root.addClass("is-loading-more");

            $.ajax({
                type: "post",
                data: {
                    action: "zp_news_ajax",
                    type: 'check_more',
                    count: $this.count,
                    offset: $this.offset + $this.count,
                },
                url: zpAjax.ajaxUrl,
                success: function (response) {

                    if(response.replace(/\s+/, "") === "") {

                        $this.ELEMENTS.$root.addClass("no-more");
                        $this.hasMore = false;

                    }

                    $this.isLoadingMore = false;
                    $this.ELEMENTS.$root.removeClass("is-loading-more");

                }
            });

        }

    }

})(jQuery, document, window);